import { Chart } from 'chart.js';
import { colors } from './data';

export var ConfigLineChart:any =  {
    interaction: {
      mode: 'index',
      intersect: false
    },
    maintainAspectRatio: false,
    indexAxis: 'x',
    categoryPercentage: 1,
    barPercentage: 0.9,
    layout: {
      padding:{
        left: 0,
        top:20,
        right: 0
      }
    },
    scales: {
      x:{
        offset: true,
          grid: {
            offset: true
          }
      },
      y1: {
        display: false,
        position: 'right',
      },
      y: {
        display: false,
        position: 'left',
       
        ticks: {
            // Include a dollar sign in the ticks
          callback: function(val:any, context) {
            var num = val;
            var digits = 2;
            const lookup = [
              { value: 1, symbol: "" },
              { value: 1e3, symbol: "k" },
              { value: 1e6, symbol: "mill" },
              // { value: 1e9, symbol: "G" },
              // { value: 1e12, symbol: "T" },
              // { value: 1e15, symbol: "P" },
              // { value: 1e18, symbol: "E" }
            ];
            const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
            var item;
              
            if(num < 0)
            {
              item = lookup.slice().reverse().find(function(item) {
                return (num)*-1 >= item.value;
              });
            }else{
              item = lookup.slice().reverse().find(function(item) {
                return num >= item.value;
              });
            }
              
            return  (item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0").toString();
          }
        }
      }
    },
  //legendTemplate : '<ul class="tc-chart-js-legend"><% for (var i=0; i<datasets.length; i++){%><li>lashdlsadj<span style="background-color:<%=datasets[i].strokeColor%>"></span><%if(datasets[i].label){%><%=datasets[i].label%><%}%></li><%}%></ul>',
  plugins: {

    legend:{
      display: true,
      position: 'top',
    //   labels:{
    //     // generateLabels: function (chart){
    //     //   var data = chart.data;
    //     //   if (data.labels.length && data.datasets.length) {
    //     //     //console.log(chart);
    //     //     return data.datasets.map(function(data, i){
    //     //       //var ds = data.datasets[0];
    //     //       var labelName = data.label.split('|');
    //     //       return{
    //     //         text: labelName[0],
    //     //         fillStyle: data.backgroundColor,
    //     //       }
    //     //     });
    //     //   }
    //     //   return [];
    //     // }
        
        
    //   }
    },
    filler: {
      propagate: true
    },
    datalabels: {
      display:'auto',
      align: 'center',
      font:{
        size: 14,
        weight: '800'
      },
      padding: 2,
      //opacity: 0.8,
      borderRadius: 5,
      boderWidth: 1,
      backgroundColor: function(context) {
        var index = context.datasetIndex;
        return context.dataset.backgroundColor;
      },
      color: "#FFFFFF",
      anchor: "end",
      formatter: function(val, context) {
        var num = val;
        var digits = 2;
        const lookup = [
          { value: 1, symbol: "" },
          { value: 1e3, symbol: "k" },
          { value: 1e6, symbol: "mill" },
          // { value: 1e9, symbol: "G" },
          // { value: 1e12, symbol: "T" },
          // { value: 1e15, symbol: "P" },
          // { value: 1e18, symbol: "E" }
        ];
        const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
        var item;
        if(num < 0)
        {
          item = lookup.slice().reverse().find(function(item) {
            return (num)*-1 >= item.value;
          });
        }else{
          item = lookup.slice().reverse().find(function(item) {
            return num >= item.value;
          });
        }
        return context.dataset.prefix + ' ' + (item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0").toString();
      }
    },
    tooltip: {
      mode: 'index',
        itemSort: function(a, b) {
          return b.raw - a.raw;
        },
        callbacks: {
          label: function(context) {
            var label = context.dataset.label || '';
            if (label) {
                label += ': ' + context.dataset.prefix;
            }
            if (context.parsed.y !== null) {
                label += new Intl.NumberFormat('es-CO', { style: 'decimal' }).format(context.parsed.y);
            }
            return label;
          }
        }
      }
    }   
  }
